import * as XLSX from 'xlsx';
import { InvoiceDetail, invoiceTotals } from '../components/admin/ClientInvoiceEditor';
import { PACK_SIZE } from './warehouseStock';

const round = (value: number, digits = 2) => Math.round((value + Number.EPSILON) * 10 ** digits) / 10 ** digits;
const formatDMY = (iso: string) => String(iso || '').slice(0, 10).split('-').reverse().join('/');

// One sheet with the invoice header (client, date, number) and its lines, ready to hand to the accountant.
export const exportInvoiceExcel = (invoice: InvoiceDetail, info: { clientName: string; clientCuit?: string; date: string; note?: string }) => {
  const totals = invoiceTotals(invoice);
  const rows: (string | number)[][] = [
    ['Factura', invoice.number || 'sin número'],
    ['Fecha', formatDMY(info.date)],
    ['Cliente', info.clientName],
    ...(info.clientCuit ? [['CUIT', info.clientCuit]] : []),
    ...(info.note ? [['Nota', info.note]] : []),
    [],
    ['Producto', 'Micronaje', 'Pedido', 'Packs', 'Bolsas', 'Precio unit. sin IVA', 'Subtotal sin IVA', 'IVA %', 'IVA', 'Total con IVA'],
    ...invoice.items.map((line) => {
      const lineTotals = invoiceTotals({ number: '', items: [line] });
      return [line.productName, line.microns || '', line.orderLabel || line.orderMonth || '', round(line.quantity / PACK_SIZE, 2), line.quantity,
        round(line.unitNet, 5), lineTotals.net, line.vatRate, lineTotals.vat, lineTotals.total];
    }),
    [],
    ['', '', '', '', '', 'Total sin IVA', totals.net],
    ['', '', '', '', '', 'IVA', round(totals.vat)],
    ['', '', '', '', '', 'Total con IVA', totals.total],
  ];
  const sheet = XLSX.utils.aoa_to_sheet(rows);
  sheet['!cols'] = [{ wch: 28 }, { wch: 11 }, { wch: 22 }, { wch: 8 }, { wch: 9 }, { wch: 18 }, { wch: 16 }, { wch: 7 }, { wch: 14 }, { wch: 15 }];
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, sheet, 'Factura');
  const safe = (text: string) => text.replace(/[^\p{L}\p{N}]+/gu, '-').replace(/^-|-$/g, '').toLowerCase();
  XLSX.writeFile(workbook, `factura-${safe(invoice.number || 'sin-numero')}-${safe(info.clientName || 'cliente')}-${String(info.date).slice(0, 10)}.xlsx`);
};
